import { render } from "./OneCard.vue?vue&type=template&id=84c5e0c0&scoped=true"
import script from "./OneCard.vue?vue&type=script&lang=js"
export * from "./OneCard.vue?vue&type=script&lang=js"

import "./OneCard.vue?vue&type=style&index=0&id=84c5e0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c5e0c0"]])

export default __exports__